import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The comprehensive knowledge of the ecological fragility of a
              region assessed at disaggregated levels through integration of
              bio-geo-climatic, ecological and social variables representing
              dynamics of socio-ecological systems, impacts, and drivers has
              aided in evolving location-specific strategies for conservation.LU
              analyses using temporal remote sensing data highlight the loss of
              evergreen forest cover of 5% with an increase of 4.5% built-up
              cover, and 9% agriculture area due to anthropogenic pressures. Due
              to unplanned developmental activities, the evergreen forest cover
              has reduced from 16 to 11% from 1985 to 2018. The fragmentation
              analysis highlights the status of forests in the Western Ghats.
              Interior forest cover has reduced from 37.14 to 25.01% over the
              past three decades. The reduction of contiguous interior cover
              affects endemic taxa and habitats and results in higher instances
              of human-wildlife conflict. Endemic taxa such as Lion-tailed
              Macaques are experiencing higher predation due to loss of
              continuity in the canopy with the fragmentation of forests.
            </p>
            <p>
              Mitigating frequent instances of human-animal conflicts requires
              addressing the fragmentation and conservation of native forests in
              the Western Ghats region. It is recommended to (i) enrich the
              dispersal corridors between the fragments patches using fruit
              trees to facilitate dietary diversity, (ii) maintain connectivity
              among canopy across linear corridors, (iii) arrest the
              deforestation by strict vigilance, protect fragments from further
              degradation, and developing forest species nurseries by involving
              local stakeholders (iv) enrich the degraded patches periodically
              with afforestation of native vegetation for long term conservation
              and (v) transparency in forest governance with mechanisms for
              accountability of forest officials for fragmentation and land
              degradation of forest landscape.The policies of maintaining forest
              contiguity would help sustain natural resources and address the
              recurring problem of human-animal conflicts due to habitat
              fragmentation.
            </p>
            <p>
              Prioritization of ecologically sensitive
              (susceptible/vulnerable/fragile) regions (ESR/EVR/EFR) at
              disaggregated levels has been done by integrating
              bio-geo-climatic, land cover, condition of ecosystems
              (fragmentation), ecological, hydrological, and social variables
              with the assignment of weights based on the extent and condition
              of ecosystems.The study emphasizes the need for conservation to
              maintain native vegetation in the catchment, highlighting its
              potential to support people&rsquo;s livelihood with water
              conservation at local and regional levels.Based on the level of
              the ecological sensitivity of the region at disaggregated levels
              considering various themes (bio-geo-climatic, ecological, and
              social variables themes), grouped into four distinct groups: ESR
              1, ESR 2, ESR 3, and ESR 4.
            </p>
            <p>
              ESR analyses highlights 39% of the geographical area of the
              Western Ghats is demarcated as ESR-1, 17% as ESR-2, 30 % as ESR-3,
              and 13 % as ESR-4. State-wise, village-level ESR analyses indicate
              that there are ecologically vulnerable villages in there are 345
              villages (of 1037 villages) in Gujarat state, 2311, and 2900
              villages under ESR-1, and 2, in Maharashtra State&nbsp; 771, and
              1111 villages (of 4911 villages) under ESR-1 and ESR-2 in
              Karnataka , 163, and 49 villages (of 841 villages in the Western
              Ghats) under ESR-1, 2 in Kerala, 261, and 144 villages (of 1407
              villages) under ESR-1, and&nbsp; 2 in&nbsp;&nbsp; Tamil Nadu.ESR-1
              and 2 are the ecologically susceptible region with higher
              ecological fragility, and hence the region's ecological integrity
              needs to be preserved without any anthropogenic interventions.
              These regions have demonstrated their utility in supporting the
              livelihood of people through (i) the sustenance of water (due to
              the presence of perennial streams), (ii) the presence of diverse
              pollinators resulting in the efficient pollination leading to
              higher crop productivity, (iii) lower instances of mudslides and
              landslides (as roots of diverse vegetation provide binding of
              soil). Hence these regions are considered restricted (no-go) areas
              for any large-scale developmental activities. Enriching the
              existing forests across the ESRs with the help of stakeholders
              would help in mitigating global warming and climate change. ESR
              1nad 2 are to be treated as No Go areas for all developmental
              activities to protect the ecosystem integrity to sustain the
              livelihood and health of people. The ESR framework acts as a
              spatial decision support systems (SDSS) tool at decentralized
              levels in the systematic assessment, monitoring of changes, and
              formulation of appropriate forest protection policies.
            </p>
            <h2>
              <strong>Acknowledgment</strong>
            </h2>
            <p>
              We are grateful to(i) EIACP_ENVIS Division, the Ministry of
              Environment, Forests and Climate Change, the Government of India
              (Grant: SP/DEOO-22-001), and(ii) the Indian Institute of Science
              (IISc/ R1011) for the ﬁnancial and infrastructure support. We
              acknowledge the support of the Forest Department (Karnataka Forest
              Department), the Government of Karnataka for giving the necessary
              permissions to undertake ecological research in the Western Ghats.
              Abhishek Bagel designed and implemented WGSDSS. We thank G R Rao,
              C Balachandran, Vishnu Mukri, and Shrikanth Naik for the
              assistance in field data collection and analyses. We would like to
              thank B.M. Prasanna and Rajesh Rana for helping in the
              village-wise analysis. We are grateful to the official languages
              section at IISc for the assistance in language editing.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
